/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {Automation} from '../../core/_models'

type Props = {
  automation: Automation
}

const UserInfoCell: FC<Props> = ({automation}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-40px overflow-hidden me-3'>
      <a href='#'>
        <div className='symbol-label'>
          <img
            src={toAbsoluteUrl(`/media/svg/customicons/icons8-trigger-32.png`)}
            className='w-50'
          />
        </div>
      </a>
    </div>
    <div>

    <div className='d-flex flex-column'>{automation.description}</div>
    <div className='line-clamp'>{ automation.expression} - Timezone : {automation.timezone} </div>
    </div>

  </div>
)

export {UserInfoCell}
